import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { KettoAssuredV2Module } from '../ketto-assured-v2/ketto-assured-v2.module';
import { UrgentBannerComponent } from './components/urgent-banner/urgent-banner.component';
import { StoryV3BannerComponent } from './story-v3-banner.component';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    StoryV3BannerComponent,
    UrgentBannerComponent
  ],
  exports: [
    StoryV3BannerComponent
  ],
  imports: [
    CommonModule,
    DonateNowModule,
    SharedModule,
    KettoAssuredV2Module,
    MatTooltipModule
  ]
})
export class StoryV3BannerModule { }
